import { render, staticRenderFns } from "./Overwatch-Search.vue?vue&type=template&id=118cc10e&scoped=true"
import script from "./Overwatch-Search.vue?vue&type=script&lang=js"
export * from "./Overwatch-Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118cc10e",
  null
  
)

export default component.exports